import { StoreState } from '@/core/models/store.interface';
import { SocialSecurityNumberMaskType } from '@nxtpeople/nxt-vue-library';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { SocialSecurityNumberMaskTypeService } from './social-security-number-mask-type.service';
const service = new SocialSecurityNumberMaskTypeService();

export interface SocialSecurityNumberMaskTypeState {
   socialSecurityNumberMaskTypes: Array<SocialSecurityNumberMaskType>;
}

const SocialSecurityNumberMaskTypeStore: Module<SocialSecurityNumberMaskTypeState, StoreState> = {
   namespaced: true,
   state: { socialSecurityNumberMaskTypes: [] },
   getters: {},
   mutations: {
      SET_SOCIAL_SECURITY_NUMBER_MASK_TYPES(state, socialSecurityNumberMaskTypes: Array<SocialSecurityNumberMaskType>) {
         state.socialSecurityNumberMaskTypes = socialSecurityNumberMaskTypes;
      },
   },
   actions: {
      async getSocialSecurityNumberMaskTypes(context, query: LocationQuery) {
         const response = await service.getSocialSecurityNumberMaskTypes({ ...query, per_page: '9999', page: '1' });
         context.commit('SET_SOCIAL_SECURITY_NUMBER_MASK_TYPES', response.data);
         return response;
      },
   },
};

export default SocialSecurityNumberMaskTypeStore;
